// Translate import
import { useTranslation } from 'react-i18next'
import { TYPES_MENU_LIST } from '../constants/menu'

function PoliticaCookies() {
  const { t } = useTranslation()

  return (
    <div id={t(TYPES_MENU_LIST.COOKIE_POLICY)}>
      <h2>
        {t('Política de')} <i>{t('Cookies')}</i>
      </h2>
      <p>
        {t('Una')} <i>{t('cookie')}</i>{' '}
        {t(
          'o galleta informática es un pequeño fichero de texto enviado por un sitio web y almacenado en el navegador del usuario, de manera que el sitio web puede consultar la actividad previa del usuario. Esto significa que una'
        )}{' '}
        <i>{t('cookie')}</i>{' '}
        {t(
          'es un fichero que se descarga en su ordenador, tableta, etc… al acceder a los SERVICIOS VICENS VIVES. Las'
        )}{' '}
        <i>{t('cookies')}</i>{' '}
        {t(
          'permiten a VICENS VIVES, entre otras cosas, almacenar y recuperar información sobre el número de visitas de los usuarios, los hábitos de navegación de los usuarios y, dependiendo de la información que contengan y de la forma en que utilice su equipo, pueden utilizarse para reconocer a los usuarios.'
        )}
      </p>
      <p>
        {t('En los SERVICIOS VICENS VIVES se utilizan los siguientes tipos de')}{' '}
        <i>{t('cookies')}</i>{' '}
        {t(
          ', las cuales son tratadas por VICENS VIVES directamente o por colaboradores terceros'
        )}
        :
      </p>
      <ul>
        <li>
          <b>
            <i>{t('Cookies')}</i> {t('técnicas')}:
          </b>{' '}
          {t(
            'Son aquellas utilizadas por VICENS VIVES que permiten al usuario la navegación a través de la página web y la utilización de las diferentes opciones o servicios que en ella existen como, por ejemplo, controlar el tráfico y la comunicación de datos, identificar la sesión, acceder a partes de acceso restringido, recordar los elementos que integran un pedido, realizar el proceso de compra de un pedido, realizar la solicitud de inscripción o participación en un evento, utilizar elementos de seguridad durante la navegación o almacenar, difundir y/o compartir contenidos.'
          )}
        </li>
        <li>
          <b>
            <i>{t('Cookies')}</i> {t('de personalización')}:
          </b>{' '}
          {t(
            'Son aquellas utilizadas por VICENS VIVES que permiten al usuario acceder al servicio con algunas características de carácter general predefinidas en función de una serie de criterios en el terminal del usuario como, por ejemplo, el idioma, el tipo de navegador a través del cual se accede al servicio, la configuración regional desde donde se accede, etc.'
          )}
        </li>
        <li>
          <b>
            <i>{t('Cookies')}</i> {t('de análisis')}:
          </b>{' '}
          {t('Son aquellas utilizadas por VICENS VIVES y')}{' '}
          <a
            href='http://www.google.com/intl/es/policies/privacy/'
            rel='noopener noreferrer'
            target='_blank'
          >
            {t('Google Analytics')}
          </a>
          ,{' '}
          {t(
            'que permiten cuantificar el número de usuarios y así realizar la medición y análisis estadístico de la utilización y actividad que hacen los usuarios de los SERVICIOS VICENS VIVES, así como elaborar perfiles de navegación de los usuarios en dichas páginas y en las aplicaciones, todo ello con el fin de introducir mejoras.'
          )}
        </li>
      </ul>
      <p>
        {t(
          'Para poder utilizar determinados servicios y funcionalidad de los SERVICIOS VICENS VIVES, es necesario que los usuarios habiliten las'
        )}{' '}
        <i>{t('cookies')}</i>{' '}
        {t('en su navegador de internet. Concretamente, mediante las “')}{' '}
        <i>{t('cookies')}</i>{' '}
        {t(
          'técnicas” VICENS VIVES podrá identificar a los usuarios registrados cada vez que accedan a los SERVICIOS VICENS VIVES, permitiendo así el acceso y uso a los servicios y funcionalidad de la página web.'
        )}
      </p>
      <p>
        {t(
          'En cualquier caso, los usuarios pueden permitir, bloquear o eliminar estas'
        )}{' '}
        <i>{t('cookies')}</i>{' '}
        {t(
          'en cualquier momento y cuando lo deseen a través de la configuración del navegador.'
        )}
      </p>
      <ul>
        <li>
          {t('Para Internet Explorer, haz clic')}{' '}
          <a
            href='http://windows.microsoft.com/es-xl/internet-explorer/delete-manage-cookies#ie=ie-10'
            rel='noopener noreferrer'
            target='_blank'
          >
            {t('aquí')}
          </a>
        </li>
        <li>
          {t('Para Mozilla Firefox, haz clic')}{' '}
          <a
            href='http://support.mozilla.org/es/kb/cookies-informacion-que-los-sitios-web-guardan-en-'
            rel='noopener noreferrer'
            target='_blank'
          >
            {t('aquí')}
          </a>
        </li>
        <li>
          {t('Para Google Chrome, haz clic')}{' '}
          <a
            href='https://support.google.com/chrome/answer/95647?hl=es'
            rel='noopener noreferrer'
            target='_blank'
          >
            {t('aquí')}
          </a>
        </li>
        <li>
          {t('Para Safari, haz clic')}{' '}
          <a
            href='http://support.apple.com/kb/HT1677?viewlocale=es_ES'
            rel='noopener noreferrer'
            target='_blank'
          >
            {t('aquí')}
          </a>
        </li>
      </ul>
      <p>
        {t(
          'VICENS VIVES recomienda acceder siempre a la información de soporte más actualizada de cada navegador para conocer la manera correcta de gestionar o eliminar las'
        )}{' '}
        <i>{t('cookies')}</i>.
      </p>
    </div>
  )
}
export default PoliticaCookies
